import React from "react";
import { Route, Routes } from "react-router-dom";
import Home from "./components/Home.jsx";
import AboutPage from "./pages/AboutPage.jsx";
import ServicePage from "./pages/ServicePage.jsx";
import BlogPage from "./pages/BlogPage.jsx";
import SuccessStoriesPage from "./pages/SuccessStories.jsx";
import ShopPage from "./pages/ShopPage.jsx";
import ContactPage from "./pages/ContactPage.jsx";
import BlogDetailPage from "./pages/BlogDetailPage.jsx";
import ShopDetailPage from "./pages/ShopDetailPage.jsx";
import PodcastDetailPage from "./pages/PodcastDetailPage.jsx";
import PodcastPage from "./pages/PodcastPage.jsx";
import UpcomingSessionInfo from "./pages/UpcomingSessionInfo.jsx";
import ServiceDetailPage from './pages/ServiceDetailPage.jsx';
import Error404 from './pages/404.jsx';
import Welcome from './pages/Welcome.jsx';
import ScrollToTop from './components/ScrollToTop.jsx';
import ServiceOne from "./pages/ServiceOne.jsx";
import ServiceTwo from "./pages/ServiceTwo.jsx";
import ServiceThree from "./pages/ServiceThree.jsx";
import ServiceFour from "./pages/ServiceFour.jsx";
import ServiceFive from "./pages/ServiceFive.jsx";
import Header from "./components/Header.jsx";
import Footer from "./components/Footer.jsx";
import HomePage from "./pages/HomePage.jsx";

const serviceOnePath = "Tg4Hn7VpD2QwXj9Zs";
const serviceTwoPath = "Zf5Wb8RtKj6Nw3QpE";
const serviceThreePath = "Vx2Tz9YmHk1Lw4JbR";
const serviceFourPath = "Mb7Kp3FwQh8Ln6CvD";
const serviceFivePath = "Jk2Vn5QmWs9Bz4RdY";

const AllRoutes = () => {
    return (
        <>
            <Header />
            <ScrollToTop />
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/shape-shifting-mastery" element={<Welcome />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/services" element={<ServicePage />} />
                <Route path="/services/:seo_url_slug" element={<ServiceDetailPage />} />
                <Route path="/blogs" element={<BlogPage />} />
                <Route path="/blogs/:category/:seo_url_slug" element={<BlogDetailPage />} />
                <Route path="/shop" element={<ShopPage />} />
                <Route path="/shop/:categorySlug/:productSlug" element={<ShopDetailPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/podcasts" element={<PodcastPage />} />
                <Route path="/podcasts/:seo_url_slug" element={<PodcastDetailPage />} />
                <Route path="/404" element={<Error404 />} />
                <Route path="/upcoming-session-info" element={<UpcomingSessionInfo />} />
                <Route path="/success-stories" element={<SuccessStoriesPage />} />
                <Route path={`/service-one/${serviceOnePath}`} element={<ServiceOne />} />
                <Route path={`/service-two/${serviceTwoPath}`} element={<ServiceTwo />} />
                <Route path={`/service-three/${serviceThreePath}`} element={<ServiceThree />} />
                <Route path={`/service-four/${serviceFourPath}`} element={<ServiceFour />} />
                <Route path={`/service-five/${serviceFivePath}`} element={<ServiceFive />} />
                <Route path="*" element={<Error404 />} />
            </Routes>
            <Footer />
        </>
    );
};

export default AllRoutes;
